export default __webpack_public_path__ + "static/media/montserrat-v15-latin-regular.0659a9f4.woff";